import React from "react";
import { money2 } from "../payrollHelpers";

export default function TaxesTab({ taxInfo }) {
  if (!taxInfo) return <div className="text-center text-slate-400 italic py-8" data-testid="payroll-taxes-tab">Loading tax estimate…</div>;
  return (
    <div data-testid="payroll-taxes-tab">
      <div className="flex items-center justify-between py-2 border-b border-slate-200 font-semibold text-[13px]">
        <span>Gross Pay</span><span>{money2(taxInfo.gross)}</span>
      </div>
      {(taxInfo.deductions || []).map((d, i) => (
        <div key={i} className="flex items-center justify-between py-1.5 text-[12.5px] text-slate-600" data-testid={`tax-line-${i}`}>
          <span>{d.label}</span><span className="text-rose-600">-{money2(d.current)}</span>
        </div>
      ))}
      <div className="flex items-center justify-between mt-3 pt-3 border-t-2 border-slate-200 font-bold text-[15px]">
        <span>Net Pay</span><span className="text-emerald-700" data-testid="tax-net-pay">{money2(taxInfo.net)}</span>
      </div>
      <div className="mt-3 text-[11px] text-slate-400 italic">Tax figures are an estimate (FICA + configured Federal/State withholding), not certified payroll tax.</div>
    </div>
  );
}
